    $(function() {

        const swiperGlobalOneElement = document.querySelector( '.announcements .slider' );
        const slideGlobalOneCount = swiperGlobalOneElement.querySelectorAll( '.announcements .slider .slides .slide' ).length;

        let swiper = null;

        if ( slideGlobalOneCount > 1 ) {
            const swiperGlobalOne = new Swiper( '.announcements .slider', {
                containerModifierClass: 'slide-',
                slideActiveClass: 'active',
                slideBlankClass: 'blank',
                slideClass: 'slide',
                slideNextClass: 'next',
                slidePrevClass: 'previous',
                slideVisibleClass: 'visible',
                wrapperClass: 'slides',
                autoHeight: true,
                loop: true,
                centeredSlides: true,
                speed: 1250,
                spaceBetween: 0,
                autoplay: {
                    delay: 7500,
                    disableOnInteraction: false,
                }
            });
        }

        const banner = document.querySelector( '.home .banner' );

        const sliderOne = document.querySelector( '.home .banner .slider.one .slides' );
        const sliderTwo = document.querySelector( '.home .banner .slider.two .slides' );

        const sliderOneSlides = sliderOne ? sliderOne.children.length : 0;
        const sliderTwoSlides = sliderTwo ? sliderTwo.children.length : 0;

        let swiperHomeOne = null;
        let swiperHomeTwo = null;

        if ( sliderOneSlides > 1 ) {
            swiperHomeOne = new Swiper( '.home .banner .slider.one', {
                containerModifierClass: 'slide-',
                slideActiveClass: 'active',
                slideBlankClass: 'blank',
                slideClass: 'slide',
                slideNextClass: 'next',
                slidePrevClass: 'previous',
                slideVisibleClass: 'visible',
                wrapperClass: 'slides',
                autoHeight: true,
                loop: true,
                centeredSlides: true,
                spaceBetween: 25,
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false,
                    waitForTransition: true,
                    pauseOnMouseEnter: true
                },
                navigation: {
                    disabledClass: 'disabled',
                    prevEl: '.home .banner .buttons .button.one',
                    nextEl: '.home .banner .buttons .button.two'
                },
                breakpoints: {
                    0: {
                        speed: 1000
                    },
                    900: {
                        speed: 1375
                    }
                }
            });
        }

        if ( sliderTwoSlides > 1 ) {
            swiperHomeTwo = new Swiper( '.home .banner .slider.two', {
                containerModifierClass: 'slide-',
                slideActiveClass: 'active',
                slideBlankClass: 'blank',
                slideClass: 'slide',
                slideNextClass: 'next',
                slidePrevClass: 'previous',
                slideVisibleClass: 'visible',
                wrapperClass: 'slides',
                autoHeight: true,
                loop: true,
                centeredSlides: true,
                spaceBetween: 25,
                autoplay: false,
                breakpoints: {
                    0: {
                        speed: 1000
                    },
                    900: {
                        speed: 1375
                    }
                }
            });
        }

        if ( swiperHomeOne && swiperHomeTwo ) {
            swiperHomeOne.controller.control = swiperHomeTwo;
            swiperHomeTwo.controller.control = swiperHomeOne;
            const resetAutoplay = () => {
                swiperHomeOne.autoplay.stop();
                swiperHomeOne.autoplay.start();
            };
            [
                swiperHomeOne,
                swiperHomeTwo
            ].forEach( sw => {
                sw.on( 'touchEnd', resetAutoplay );
            });
            swiperHomeOne.on( 'slideChangeTransitionEnd', resetAutoplay );
            const removeInitialAutoplay = swiper => {
                [
                    0,
                    1,
                    2
                ].forEach( i => swiper.slides[i]?.removeAttribute( 'data-swiper-autoplay' ) );
            };
            swiperHomeOne.on( 'slideChangeTransitionEnd', () => removeInitialAutoplay( swiperHomeOne ) );
            swiperHomeTwo.on( 'slideChangeTransitionEnd', () => removeInitialAutoplay( swiperHomeTwo ) );
        }

        if ( banner ) {
            if ( swiperHomeOne || swiperHomeTwo ) {
                banner.setAttribute( 'data-slider', '1' );
            } else {
                banner.setAttribute( 'data-slider', '0' );
            }
        }

        const swiperHomeThree = new Swiper( '.home .features .slider', {
            containerModifierClass: 'slide-',
            slideActiveClass: 'active',
            slideBlankClass: 'blank',
            slideClass: 'slide',
            slideNextClass: 'next',
            slidePrevClass: 'previous',
            slideVisibleClass: 'visible',
            wrapperClass: 'slides',
            speed: 750,
            navigation: {
                disabledClass: 'disabled',
                prevEl: '.home .features .navigation .buttons .button.one',
                nextEl: '.home .features .navigation .buttons .button.two'
            },
            breakpoints: {
                0: {
                    spaceBetween: 12,
                    slidesPerView: 1,
                    speed: 500
                },
                600: {
                    spaceBetween: 12,
                    slidesPerView: 2,
                    speed: 500
                },
                900: {
                    spaceBetween: 12,
                    slidesPerView: 3,
                    speed: 750
                },
                1250: {
                    spaceBetween: 12,
                    slidesPerView: 3,
                    speed: 750
                }
            }
        });

        const swiperHomeFour = new Swiper( '.home .products .slider', {
            containerModifierClass: 'slide-',
            slideActiveClass: 'active',
            slideBlankClass: 'blank',
            slideClass: 'slide',
            slideNextClass: 'next',
            slidePrevClass: 'previous',
            slideVisibleClass: 'visible',
            wrapperClass: 'slides',
            navigation: {
                disabledClass: 'disabled',
                prevEl: '.home .products .navigation .buttons .button.one',
                nextEl: '.home .products .navigation .buttons .button.two'
            },
            breakpoints: {
                0: {
                    spaceBetween: 12,
                    slidesPerView: 2,
                    speed: 500
                },
                600: {
                    spaceBetween: 12,
                    slidesPerView: 2,
                    speed: 500
                },
                900: {
                    spaceBetween: 12,
                    slidesPerView: 3,
                    speed: 750
                },
                1250: {
                    spaceBetween: 12,
                    slidesPerView: 4,
                    speed: 750
                }
            },
        });

        const swiperHomeFive = new Swiper( '.home .introduction .slider.one', {
            containerModifierClass: 'slide-',
            slideActiveClass: 'active',
            slideBlankClass: 'blank',
            slideClass: 'slide',
            slideNextClass: 'next',
            slidePrevClass: 'previous',
            slideVisibleClass: 'visible',
            wrapperClass: 'slides',
            loop: true,
            spaceBetween: 8,
            speed: 750,
            autoplay: {
                delay: 3750,
                disableOnInteraction: false,
            },
            breakpoints: {
                0: {
                    slidesPerView: 2
                },
                600: {
                    slidesPerView: 3
                },
                900: {
                    slidesPerView: 4
                },
                1250: {
                    slidesPerView: 5
                }
            },
        });

        const swiperHomeSix = new Swiper( '.home .introduction .slider.two', {
            containerModifierClass: 'slide-',
            slideActiveClass: 'active',
            slideBlankClass: 'blank',
            slideClass: 'slide',
            slideNextClass: 'next',
            slidePrevClass: 'previous',
            slideVisibleClass: 'visible',
            wrapperClass: 'slides',
            loop: true,
            spaceBetween: 8,
            speed: 750,
            autoplay: {
                delay: 3750,
                disableOnInteraction: false,
                reverseDirection: true,
            },
            breakpoints: {
                0: {
                    slidesPerView: 2
                },
                600: {
                    slidesPerView: 3
                },
                900: {
                    slidesPerView: 4
                },
                1250: {
                    slidesPerView: 5
                }
            },
        });

        function resetSwipers() {
            swiperHomeFive.autoplay.stop();
            swiperHomeSix.autoplay.stop();
            setTimeout( () => {
                swiperHomeFive.autoplay.start();
                swiperHomeSix.autoplay.start();
            }, 0 );
        }

        swiperHomeFive.on( 'slideChangeTransitionEnd', resetSwipers );
        swiperHomeSix.on( 'slideChangeTransitionEnd', resetSwipers );

    });

    document.addEventListener( 'DOMContentLoaded', function () {
        var tabs = document.querySelectorAll( '.home .palettes .content .sections .section.three .blocks .block .links ul li' );
        var palettes = document.querySelectorAll( '.home .palettes .content .sections .section.four .blocks[data-blocks="1"] > .block[data-palette]' );
        function showPalette( name ) {
            palettes.forEach( function ( palette ) {
                var match = palette.getAttribute( 'data-palette' ) === name;
                if ( match ) {
                    palette.classList.add( 'active' );
                } else {
                    palette.classList.remove( 'active' );
                }
            });
        }
        tabs.forEach( function ( tab ) {
            tab.addEventListener( 'click', function ( event ) {
                var link = tab.querySelector( 'a' );
                if ( link ) {
                    event.preventDefault();
                }
                var paletteName = tab.getAttribute( 'data-palette' );
                if ( ! paletteName ) {
                    return;
                }
                tabs.forEach( function ( item ) {
                    item.classList.remove( 'active' );
                });
                tab.classList.add( 'active' );
                showPalette( paletteName );
            });
        });
        var activeTab = document.querySelector( '.home .palettes .content .sections .section.three .blocks .block .links ul li.active' );
        if ( activeTab && activeTab.getAttribute( 'data-palette' ) ) {
            showPalette( activeTab.getAttribute( 'data-palette' ) );
        } else if ( palettes[ 0 ] ) {
            palettes[ 0 ].classList.add( 'active' );
        }
    });
